import styled from 'react-emotion'
import { mobile, customDevice } from '../../utils/mixins'

export const ResponsiveContainer = styled('div')`
  width: 1124px;
  margin: auto;
  display: flex;
  flex-direction: column;
  ${mobile} {
    width: 88.8%;
  }
  ${customDevice(768, 959)} {
    width: 90%;
  }
  ${customDevice(960, 1200)} {
    width: 90%;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/styledComponents.js